"use client";

import { ReactNode, useEffect } from "react";
import { initializeErrorTracking } from "@/lib/error-tracking";
import ErrorBoundary from "./ErrorBoundary";

interface ErrorTrackingProviderProps {
  children: ReactNode;
}

export const ErrorTrackingProvider = ({
  children,
}: ErrorTrackingProviderProps) => {
  useEffect(() => {
    initializeErrorTracking();
  }, []);

  return <ErrorBoundary>{children}</ErrorBoundary>;
};
